import { render, staticRenderFns } from "./ChargesPopUp.vue?vue&type=template&id=220acf38&scoped=true&"
import script from "./ChargesPopUp.vue?vue&type=script&lang=js&"
export * from "./ChargesPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ChargesPopUp.vue?vue&type=style&index=0&id=220acf38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220acf38",
  null
  
)

export default component.exports